import { on } from "delegated-events";

import lightGallery from "lightgallery";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgVideo from "lightgallery/plugins/video";

import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-thumbnail.css";
import "lightgallery/css/lg-video.css";

const licenseKey = "82F2B691-7585-4DCE-999C-3B5FFDB69F93";

const openPhotoGallery = (trigger) => {
  const gallery = trigger.closest("[data-photo-gallery]");
  const galleryIndex = trigger.dataset.galleryIndex;
  const startIndex = galleryIndex === undefined ? 0 : parseInt(galleryIndex) - 1;
  const galleryData = JSON.parse(gallery.dataset.photoGallery);

  const lg = lightGallery(gallery, {
    plugins: [lgThumbnail, lgVideo],
    licenseKey,
    index: startIndex,
    dynamic: true,
    dynamicEl: galleryData,
    thumbnail: true,
    download: false,
    hideBarsDelay: 5000,
    autoplayVideoOnSlide: true,
    youTubePlayerParams: {
      modestbranding: 1,
      showinfo: 0,
      controls: 1,
      mute: 0,
      rel: 0,
    },
  });

  lg.openGallery();
};

const openSinglePhoto = (trigger) => {
  const data = [
    {
      src: trigger.href,
      subHtml: `<p>${trigger.textContent}</p>`,
    },
  ];

  const lg = lightGallery(trigger, {
    licenseKey,
    dynamic: true,
    dynamicEl: data,
    download: false,
    enableDrag: false,
    enableSwipe: false,
    hideBarsDelay: 0,
    addClass: "as-single-photo",
    counter: false,
  });

  lg.openGallery();
};

on("click", ".photo-gallery-trigger", (e) => {
  e.preventDefault();

  const trigger = e.target.closest(".photo-gallery-trigger");

  openPhotoGallery(trigger);
});

on("click", ".lightbox-trigger", (e) => {
  e.preventDefault();

  const trigger = e.target.closest(".lightbox-trigger");

  openSinglePhoto(trigger);
});
